import React from 'react';
import { SvgIcon } from '@mui/material';
import { iconType } from './icon-types';

const MapMarkerIcon = (properties: iconType) => {
  const { width, height, strokeWidth } = properties;
  return (
    <SvgIcon
      {...properties}
      viewBox="0 0 22 31"
      style={{
        fill: 'none',
        width: `${width || '22px'}`,
        height: `${height || '31px'}`,
        strokeWidth,
      }}
    >
      <path d="M10.6252 12.2292C11.5111 12.2292 12.2293 11.511 12.2293 10.625C12.2293 9.73908 11.5111 9.02087 10.6252 9.02087C9.73921 9.02087 9.021 9.73908 9.021 10.625C9.021 11.511 9.73921 12.2292 10.6252 12.2292Z" />
      <path d="M20.25 10.625C20.25 15.9444 10.625 29.875 10.625 29.875C10.625 29.875 1 15.9444 1 10.625C1 5.30558 5.312 1 10.625 1C15.938 1 20.25 5.30558 20.25 10.625Z" />
    </SvgIcon>
  );
};

export default MapMarkerIcon;
